module.exports = __webpack_public_path__ + "img/product-clickflare-img.a5558aab.jpg";